import { render, staticRenderFns } from "./rate.vue?vue&type=template&id=7195f28e&scoped=true&"
import script from "./rate.vue?vue&type=script&lang=js&"
export * from "./rate.vue?vue&type=script&lang=js&"
import style0 from "./rate.vue?vue&type=style&index=0&id=7195f28e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7195f28e",
  null
  
)

export default component.exports